
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/logo.png";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaYoutube
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-top">

        {/* LOGO + ABOUT */}
        <div className="footer-section">

          <img
            src={logo}
            alt="School Logo"
            className="footer-logo"
          />

          <p>
            Lotus Lap Public School is committed to nurturing
            young minds with quality education, discipline,
            and values for a bright future.
          </p>

        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">

          <h3>Quick Links</h3>

          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/academics">Academics</Link></li>
            <li><Link to="/admission">Admission</Link></li>
            <li><Link to="/infrastructure">Infrastructure</Link></li>
            <li><Link to="/amruthavanam">Amruthavanam</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>

        </div>

        {/* CONTACT */}
        <div className="footer-section">

          <h3>Contact Us</h3>

          <div className="contact-branches">

            {/* SAROORNAGAR */}
            <div className="branch-contact">

              <h4>Saroornagar Branch</h4>

              <p>
                <FaPhoneAlt />
                9553741544
              </p>

              <p>
                <FaEnvelope />
                lotuslap_school_kpt@ymail.com
              </p>

              <p>
                <FaMapMarkerAlt />
                Saroornagar, HUDA Complex, Kothapet
              </p>

              <p className="timings">
                Timings: 8:00 AM to 5:30 PM
              </p>

              {/* SOCIAL MEDIA */}
              <div className="branch-socials">

                <a
                  href="https://www.facebook.com/lotus.karmanghat"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                </a>

                <a
                  href="https://www.instagram.com/lotuslap_srnr?igsh=MWRlemNuYzQ4OHEzZg=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://www.youtube.com/@lotuslapeventshyd8707"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>

              </div>

            </div>

            {/* KARMANGHAT */}
            <div className="branch-contact">

              <h4>Karmanghat Branch</h4>

              <p>
                <FaPhoneAlt />
                9553763144
              </p>

              <p>
                <FaEnvelope />
               lotuslap_school_krgt@ymail.com
              </p>

              <p>
                <FaMapMarkerAlt />
                Lotus Lap Public School,
                Mandamallamma, Karmanghat
              </p>

              <p className="timings">
                Timings: 8:00 AM to 5:30 PM
              </p>

              {/* SOCIAL MEDIA */}
              <div className="branch-socials">

                <a
                  href="https://www.facebook.com/lotus.karmanghat"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook />
                </a>

                <a
                  href="https://www.instagram.com/lotuslapschoolkharmanghat?igsh=MTVpY2syanRkZHgwYQ%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://www.youtube.com/@lotuslapeventshyd8707"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube />
                </a>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">

        <p>
          © 2026 Lotus Lap Public School.
          All Rights Reserved.
        </p>

      <p>
  Powered by VRND Business Solutions
</p>

      </div>

    </footer>
  );
}

export default Footer;

